import { createSlice } from '@reduxjs/toolkit';

import { patientApi } from '../api/patientApi';

import type { PayloadAction } from '@reduxjs/toolkit';

type AppState = {
  dischargePrompt: boolean,
  hospitalLogo: string | null,
  appVariant: string,
  procedureLogo: string | null,
  route: string | null,
  secureMessagingEnabled: boolean;
  testEnv: boolean,
  theme: 'light' | 'dark';
  unitPref: string | null,
};

const initialState = {
  dischargePrompt: true,
  appVariant: 'seamless',
  route: null,
  testEnv: false,
  theme: 'light',
  secureMessagingEnabled: false,
  unitPref: null,
} as AppState;

const slice = createSlice({
  name: 'app',
  initialState,

  reducers: (create) => ({
    setDischargePrompt: create.reducer((
      state,
      { payload: dischargePrompt }: PayloadAction<boolean>,
    ) => {
      state.dischargePrompt = dischargePrompt;
    }),

    setAppVariant: create.reducer((
      state,
      { payload: appVariant }: PayloadAction<string>,
    ) => {
      state.appVariant = appVariant;
    }),

    setRoute: create.reducer((
      state,
      { payload: route }: PayloadAction<string>,
    ) => {
      state.route = route;
    }),

    setTestEnv: create.reducer((
      state,
      { payload: testEnv }: PayloadAction<boolean>,
    ) => {
      state.testEnv = testEnv;
    }),

    setTheme: create.reducer((
      state,
      { payload: theme }: PayloadAction<'light' | 'dark'>,
    ) => {
      state.theme = theme;
    }),

    setUnitPref: create.reducer((
      state,
      { payload: unitPref }: PayloadAction<string>,
    ) => {
      state.unitPref = unitPref;
    }),

  }),

  extraReducers: (builder) => {
    builder
      .addMatcher(
        patientApi.endpoints.getPatient.matchFulfilled,
        (state, { payload }) => {
          if (!payload) return;
          if (payload.server === 'US') {
            state.unitPref = 'imperial';
          }
          if (payload.server === 'CA') {
            state.unitPref = 'metric';
          }
        },
      )
      .addMatcher(
        patientApi.endpoints.getPatient.matchFulfilled,
        (state, { payload }) => {
          if (!payload) return;
          state.procedureLogo = payload.procedureLogo;
          state.secureMessagingEnabled = payload.secureMessagingEnabled;
        },
      )
  }
});

export const {
  setDischargePrompt,
  setAppVariant,
  setRoute,
  setTestEnv,
  setTheme,
  setUnitPref,
} = slice.actions;

export default slice.reducer;
